import { FocusManager } from '@react-aria/focus';
import { Option } from '../option';

export function moveFocusNext(
    focusManager: FocusManager | undefined,
    value: string | number | boolean | Option | (string | number | boolean)[],
    isMultiple?: boolean
) {
    // Don't move focus from a multi select or value is being deleted
    if (focusManager && !isMultiple && !!value) {
        setTimeout(() => focusManager?.focusNext({ tabbable: true }), 0);
    }
}
